import styled from "styled-components";

export const Wrapper = styled.div`
  .search-container {
    position: relative;
    width: 100%;
  }
  .top-bar-row {
    margin-bottom: ${props => props.isSmall ? '5px' : '40px'};
  }
  .search-box {
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
    padding: 3px 15px;
    border-radius: 10px;
    width: 100%;
    
  }
  .icon {
    position: absolute;
    top: ${props => props.isSmall ? '18px' : '20px'};
    right: 20px;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .add-desktop-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search-button:hover {
    border: 2px solid black;
  }
  .search-button {
    padding: 20px 20px;
    height: 40px;
    span {
      vertical-align: middle;
    }
  }
  .search-button {
    padding: 5px 20px;
    @media (max-width: 991.5px) {
      margin-top: 15px;
    }
  }
  .search-button:hover {
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
      height: 40px;
  }
  .search-button {
    padding: 18px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search-row {
    display: flex;
    align-items: center;
  }
  .line {
    border-top: 3px solid black;
    width: 780px;
    margin: 20px 0;
    position: relative;
    left: 55px;
  }
  .add-cus-small-text {
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
   
  }
  @media only screen and (max-width: 618px) {
      .add-cus-small-text {
          font-size: 14px;
          font-weight: 600;
      }
  }
  @media only screen and (max-width: 569px) {
      .add-cus-small-text {
          font-size: 12px;
          font-weight: 600;
      }
  }

  .sm-add-users-container {
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.isSmall ? 'space-between' : 'flex-end'};
    align-items: center;
    gap: ${props => props.isSmall ? '10px' : '35px'};
    margin-top: ${props => props.isSmall ? '10px' : '0'};
    margin-bottom: ${props => props.isSmall ? '0' : '20px'};
    white-space: nowrap;
    

    .sm-add-users-title {
      font-size: 16px;
      font-weight: 600;
     
    }
    .sm-add-users-hr {
      width: ${props => props.isSmall ? '60%' : '85%'};
      height: 2px;
      background: black;
    }
    .sm-add-users-button {
      height: 25px;
      width: 25px;
    }
  }

  .ant-table {
    table-layout: fixed;
  }
  .ant-table-tbody > tr > td {
    max-width: 200px;
    min-width: 70px;
    border-bottom: 1px solid rgb(231, 216, 216);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
  }
  @media screen and (max-width: 991px) {
    #switch {
      padding-top: 5px !important;
      padding-left: 0px !important;
      /* padding-right: 65px !important; */
    }
  }
  @media screen and (max-width: 767px) {
    #switch {
   
      display: flex;
      justify-content: end;
    }
  }
`;

export const UserWrapper = styled.div`
  .ant-form {
    width: 100%;
    label {
      color: #566787;
      font-size: 15px;
      width: 100px;
    }
  }
  .modal-input {
    border: 1px solid #dddddd;
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 10px;
    ::placeholder {
      color: #566787;
      font-size: 15px;
    }
  }
  .modal-label {
    color: #566787;
    padding-left: 16px;
    padding-right: 8px;
    font-size: 15px;
  }
  .ant-switch {
    vertical-align: top;
    margin-left: 10px;
  }
  .ant-modal-body {
    padding: 24px 24px 15px 24px;
  }
  .switch-col {
    margin-top: 10px;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    width: 100%;
    height: 40px;
    padding: 4px 15px;
    font-size: 15px;
  }
  .ant-select-selector {
    border: 1px solid #dddddd !important;
    margin-left: 10px;
  }
  .ant-select-selection-placeholder {
    color: #566787 !important;
  }
  .ant-form-horizontal .ant-form-item-label {
    display: flex;
    align-items: center;
    height: 41px;
    width: 160px;
  }
  .ant-form-item-control-input {
    min-height: 38px;
    display: flex;
    justify-content: end;
  }
  .modal-check {
    margin-left: 10px;
    margin-top: 2px;
  }

  @media screen and (max-width: 580px) {
    .company-input-col {
      margin-top: 15px;
    }
  }
  @media only screen and (max-width: 880px) {
    .ant-col switch {
      border: 10px solid red;
    }
  }
`;
